export default __webpack_public_path__ + "static/media/paris.457fb0cd.png";